import { LoadScript } from '@react-google-maps/api';

export const GoogleMapProvider = ({ children }: any) => (
  <LoadScript googleMapsApiKey={process.env.REACT_APP_GEO_APIKEY}>
    {children}
  </LoadScript>
);